import React from "react";

import { getCheckInCategory } from "./checkIn";
import {
    CategoryIconWrapper,
    LocationAddress,
    LocationName,
    LocationText,
    ResultButton
} from "./CheckInControls.styled";

const CheckInSearchResult = ({ location, selectedCategory, onSelect }) => {
    const category = getCheckInCategory(location.category);

    return (
        <ResultButton
            type="button"
            $color={category.color}
            $softColor={category.softColor}
            onMouseDown={event => event.preventDefault()}
            onClick={() => onSelect({
                ...location,
                category: selectedCategory || location.category
            })}
        >
            <CategoryIconWrapper $color={category.color}>
                <img src={category.icon} alt="" />
            </CategoryIconWrapper>
            <LocationText>
                <LocationName>{location.placeName}</LocationName>
                <LocationAddress>{location.formattedAddress}</LocationAddress>
            </LocationText>
        </ResultButton>
    );
};

export default CheckInSearchResult;
